/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  street1?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  street2?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  state?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  zip?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  country?: string;
  /**
   *
   * @type {number}
   * @memberof Address
   */
  id?: number;

  mailOption?: string;
  isSea?: boolean;
  /**
   * Marks the customer's primary address. Exactly one entry in
   * CourierUser.addresses carries this; the backend normalizer enforces it.
   * @type {boolean}
   * @memberof Address
   */
  isPrimary?: boolean;
  /**
   * Optional map coordinates for the address (LoopBack `geopoint`).
   * @type {{ lat: number; lng: number }}
   * @memberof Address
   */
  coordinates?: { lat: number; lng: number };
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
  return true;
}

export function AddressFromJSON(json: any): Address {
  return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Address {
  if (json == null) {
    return json;
  }
  return {
    street1: json['street1'] == null ? undefined : json['street1'],
    street2: json['street2'] == null ? undefined : json['street2'],
    city: json['city'] == null ? undefined : json['city'],
    state: json['state'] == null ? undefined : json['state'],
    zip: json['zip'] == null ? undefined : json['zip'],
    country: json['country'] == null ? undefined : json['country'],
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    mailOption: json['mailOption'] == null ? undefined : json['mailOption'],
    isSea: json['isSea'] == null ? undefined : json['isSea'],
    isPrimary: json['isPrimary'] == null ? undefined : json['isPrimary'],
    coordinates: json['coordinates'] == null ? undefined : json['coordinates'],
  };
}

export function AddressToJSON(json: any): Address {
  return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(
  value?: Address | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    street1: value['street1'],
    street2: value['street2'],
    city: value['city'],
    state: value['state'],
    zip: value['zip'],
    country: value['country'],
    id: value['id'],
    name: value['name'],
    mailOption: value['mailOption'],
    isSea: value['isSea'],
    isPrimary: value['isPrimary'],
    coordinates: value['coordinates'],
  };
}
